(() => {
  const preview = document.querySelector('[data-wr-saved-preview]');
  if (!preview) return;

  const content = preview.querySelector('[data-wr-saved-preview-content]');
  const title = preview.querySelector('#wr-saved-preview-title');
  const editLink = preview.querySelector('[data-wr-saved-preview-edit]');
  const closeButton = preview.querySelector('[data-wr-saved-preview-close]');
  const triggers = Array.from(document.querySelectorAll('[data-wr-saved-preview-trigger]'));
  let lastActiveElement = null;
  let activeTrigger = null;

  const requestUrl = (trigger) => {
    const prefix = String(trigger.dataset.wrPreviewAppPrefix || '').replace(/\/$/, '');
    const params = new URLSearchParams({
      book_number: trigger.dataset.wrPreviewBookNumber || '',
      preview_session_id: trigger.dataset.wrPreviewSessionId || '',
      access_token: trigger.dataset.wrPreviewAccessToken || '',
      cover_selection: trigger.dataset.wrPreviewCoverSelection || '',
    });
    return `${prefix}/api/saved-preview?${params.toString()}`;
  };

  const setPreviewOpen = (isOpen) => {
    preview.classList.toggle('is-active', isOpen);
    preview.toggleAttribute('hidden', !isOpen);
    preview.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    document.documentElement.classList.toggle('wr-saved-preview-open', isOpen);
  };

  const closePreview = () => {
    setPreviewOpen(false);
    content.replaceChildren();
    editLink.hidden = true;
    if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
      lastActiveElement.focus();
    }
    activeTrigger = null;
  };

  const trapFocus = (event, container) => {
    if (event.key !== 'Tab') return;
    const focusable = Array.from(container.querySelectorAll(
      'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter((element) => !element.hidden);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  const createPages = (pages) => {
    const pagesContainer = document.createElement('div');
    pagesContainer.className = 'wr-saved-preview__pages';
    pages.forEach((page, index) => {
      const image = document.createElement('img');
      image.className = 'wr-saved-preview__page';
      image.src = page.url;
      image.alt = page.label || `Preview page ${index + 1}`;
      image.loading = index === 0 ? 'eager' : 'lazy';
      image.decoding = 'async';
      pagesContainer.appendChild(image);
    });
    return pagesContainer;
  };

  const loadManifest = async (trigger) => {
    const response = await fetch(requestUrl(trigger), { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Saved preview is unavailable.');
    const data = await response.json();
    if (!Array.isArray(data.pages) || !data.pages.length) throw new Error('Saved preview is unavailable.');
    return data;
  };

  const verifyTrigger = async (trigger) => {
    try {
      await loadManifest(trigger);
      trigger.hidden = false;
    } catch (_) {
      trigger.remove();
    }
  };

  const openPreview = async (trigger) => {
    lastActiveElement = document.activeElement;
    activeTrigger = trigger;
    title.textContent = trigger.dataset.wrPreviewTitle || 'Your personalized book';
    content.innerHTML = '<div class="wr-saved-preview__loading">Loading your saved preview...</div>';
    const editUrl = trigger.dataset.wrPreviewEditUrl || '';
    editLink.hidden = !editUrl;
    editLink.href = editUrl || '#';
    setPreviewOpen(true);
    closeButton.focus();

    try {
      const manifest = await loadManifest(trigger);
      if (activeTrigger !== trigger) return;
      content.replaceChildren(createPages(manifest.pages));
    } catch (_) {
      trigger.remove();
      closePreview();
    }
  };

  triggers.forEach((trigger) => {
    verifyTrigger(trigger);
    trigger.addEventListener('click', () => openPreview(trigger));
  });

  closeButton.addEventListener('click', closePreview);
  preview.addEventListener('click', (event) => {
    if (event.target === preview) closePreview();
  });
  preview.addEventListener('keydown', (event) => trapFocus(event, preview));
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (preview.classList.contains('is-active')) closePreview();
  });

  const params = new URLSearchParams(window.location.search);
  const updatedKey = params.get('wr_personalization_updated');
  if (updatedKey) {
    const updatedItem = Array.from(document.querySelectorAll('[data-item-row][data-line]'))
      .find((item) => item.dataset.line === updatedKey);
    if (updatedItem) {
      updatedItem.setAttribute('tabindex', '-1');
      updatedItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
      updatedItem.focus({ preventScroll: true });
      const notice = document.createElement('p');
      notice.className = 'wr-cart-update-notice';
      notice.setAttribute('role', 'status');
      notice.textContent = 'Your personalized book has been updated.';
      updatedItem.before(notice);
    }
    params.delete('wr_personalization_updated');
    const nextQuery = params.toString();
    window.history.replaceState({}, '', `${window.location.pathname}${nextQuery ? `?${nextQuery}` : ''}${window.location.hash}`);
  }
})();
